const splitJoin = (value: string, split: string, join: string) => {
	return value.split(split).join(join);
};
export default splitJoin;
